import { Component, DestroyRef, effect, inject, input, signal } from '@angular/core';
import { DashboardChartTooltipData } from './dashboard-chart-tooltip.types';

const HIDE_DELAY_MS = 150;

@Component({
    selector: 'app-dashboard-chart-tooltip',
    templateUrl: './dashboard-chart-tooltip.component.html',
    styleUrl: './dashboard-chart-tooltip.component.scss',
})
export class DashboardChartTooltipComponent {
    public readonly data = input<DashboardChartTooltipData | null>(null);

    protected readonly displayedData = signal<DashboardChartTooltipData | null>(null);

    private readonly destroyRef = inject(DestroyRef);
    private hideTimeout: ReturnType<typeof setTimeout> | null = null;
    private hovered = false;

    constructor() {
        effect(() => {
            const data = this.data();
            if (data) {
                this.cancelHide();
                this.displayedData.set(data);
                return;
            }

            this.scheduleHide();
        });

        this.destroyRef.onDestroy(() => this.cancelHide());
    }

    protected handlePointerEnter(): void {
        this.hovered = true;
        this.cancelHide();
    }

    protected handlePointerLeave(): void {
        this.hovered = false;
        if (!this.data()) this.displayedData.set(null);
    }

    private scheduleHide(): void {
        this.cancelHide();
        this.hideTimeout = setTimeout(() => {
            this.hideTimeout = null;
            if (!this.hovered && !this.data()) this.displayedData.set(null);
        }, HIDE_DELAY_MS);
    }

    private cancelHide(): void {
        if (this.hideTimeout === null) return;

        clearTimeout(this.hideTimeout);
        this.hideTimeout = null;
    }
}
